import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMyAdsList } from './useMyAdsList';
import { AdStatus } from '@/types';
import { BULK_PROMOTION_MAX_SELECTION } from '@/features/Profile/sections/MyAds/MyAdsSection.constants';
import { useToastStore } from '@/store/useToastStore';

export function useMyAdsBulkPromotion() {
  const { t } = useTranslation();
  const { openToast } = useToastStore();
  const list = useMyAdsList(AdStatus.Published);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  function isSelected(id: string) {
    return selectedIds.includes(id);
  }

  function toggle(id: string) {
    if (isSelected(id)) {
      setSelectedIds(currentIds =>
        currentIds.filter(selectedId => selectedId !== id)
      );
      return;
    }

    if (selectedIds.length >= BULK_PROMOTION_MAX_SELECTION) {
      openToast({
        text: t('pages.cabinet.bulk_promotion_limit_reached', {
          count: BULK_PROMOTION_MAX_SELECTION,
        }),
        size: 'compact',
        borderRadius: 14,
      });
      return;
    }

    setSelectedIds(currentIds => [...currentIds, id]);
  }

  return {
    ...list,
    canContinue: selectedIds.length > 0,
    isSelected,
    selectedCount: selectedIds.length,
    selectedIds,
    toggle,
  };
}
